import React, { useState } from 'react';
import { Box, Link } from '@mui/material';
import TermsOfServiceDialog from './TermsOfServiceDialog';

const Footer = () => {
  const [termsDialogOpen, setTermsDialogOpen] = useState(false);

  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        width: '100%',
        textAlign: 'center',
        padding: '16px',
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #ddd',
      }}
    >
      <Link href="#" onClick={() => setTermsDialogOpen(true)}>
        Terms of Service
      </Link>
      <TermsOfServiceDialog open={termsDialogOpen} onClose={() => setTermsDialogOpen(false)} />
    </Box>
  );
};

export default Footer; 